import script from "./EmailBoxView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailBoxView.vue?vue&type=script&setup=true&lang=js"

import "./EmailBoxView.vue?vue&type=style&index=0&id=09b3f42e&lang=css"

const __exports__ = script;

export default __exports__